const round = (num: number, type: 'up' | 'down' | 'round') => {
	if (10000 > num)
		return {
			up: Math.ceil(num).toLocaleString(),
			down: Math.floor(num).toLocaleString(),
			round: Math.round(num).toLocaleString(),
		}[type];

	if (num >= 10000 && 1000000 > num)
		return {
			up: Math.ceil(num / 1000) / 10 + '만',
			down: Math.floor(num / 1000) / 10 + '만',
			round: Math.round(num / 1000) / 10 + '만',
		}[type];

	if (num >= 1000000 && 100000000 > num)
		return {
			up: Math.ceil(num / 10000).toLocaleString() + '만',
			down: Math.floor(num / 10000).toLocaleString() + '만',
			round: Math.round(num / 10000).toLocaleString() + '만',
		}[type];

	if (num >= 100000000 && 10000000000 > num)
		return {
			up: Math.ceil(num / 10000000) / 10 + '억',
			down: Math.floor(num / 10000000) / 10 + '억',
			round: Math.round(num / 10000000) / 10 + '억',
		}[type];

	if (num >= 10000000000)
		return {
			up: Math.ceil(num / 100000000).toLocaleString() + '억',
			down: Math.floor(num / 100000000).toLocaleString() + '억',
			round: Math.round(num / 100000000).toLocaleString() + '억',
		}[type];

	return null;
};

export const roundFloat = (num: number, type: 'up' | 'down' | 'round', fixed: number) => {
	const fixed_num = +`1${new Array(fixed).fill('0').join('')}`;

	return {
		up: Math.ceil(num * fixed_num) / fixed_num,
		down: Math.floor(num * fixed_num) / fixed_num,
		round: Math.round(num * fixed_num) / fixed_num,
	}[type];
};

export const floatFixed = (value: number | string, fixed: number) => {
	const num = typeof value === 'string' ? value : value.toString();

	return parseFloat(num).toFixed(fixed);
};

export default round;
